import React, { useState } from "react";
import FadeAlert, {
  FadeAlertType,
} from "../../components/FadeAlert/FadeAlert.tsx";
import DatePicker from "../../components/Forms/DatePicker/DatePicker.tsx";
import { useAuth } from "../../provider/AuthProvider.tsx";
import PolicyService from "../../services/PolicyService/PolicyService.ts";
import { revertNormalizeDate } from "../../utils/NormalizationUtil.ts";
import Breadcrumb from "../../components/Breadcrumbs/Breadcrumb.tsx";
import SectionHeader from "../../components/SectionHeader/SectionHeader.tsx";

const FinancialAuditReport: React.FC = () => {
  const [formState, setFormState] = useState({
    startDate: "",
    endDate: "",
    extPol: false,
  });
  const [alert, setAlert] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<FadeAlertType>();
  const [isLoading, setIsLoading] = useState(false);
  const { jwt } = useAuth();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formState.startDate || !formState.endDate) {
      setAlert("Моля, въведете начална и крайна дата");
      setAlertType(FadeAlertType.error);
      return;
    }
    try {
      setIsLoading(true);
      setAlert(null);
      const result = await PolicyService.fetchKFNAuditReport(
        {
          startDate: revertNormalizeDate(formState.startDate),
          endDate: revertNormalizeDate(formState.endDate),
          extPol: formState.extPol ? "1" : "0",
        },
        jwt
      );
      if (result.url) {
        window.open(`${result.url}`, "_blank");
        setAlert(
          "Справката е успешно генерирана. Проверете изтеглените Ви файлове."
        );
        setAlertType(FadeAlertType.success);
      } else {
        setAlert("Неуспешно генериране на справка.");
        setAlertType(FadeAlertType.error);
      }
    } catch (err) {
      setAlert("Грешка при изпращане на заявката.");
      setAlertType(FadeAlertType.error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb pageName="Справка за КФН" />
      <div className="border-stroke shadow-default dark:border-strokedark dark:bg-boxdark rounded-sm border bg-white">
        <FadeAlert
          alert={alert}
          type={alertType}
          onClose={() => setAlert(null)}
        />

        <SectionHeader title="Справка за КФН" />

        <form onSubmit={handleSubmit} className="p-3">
          <div className="grid grid-cols-2 gap-2 lg:grid-cols-4">
            <div>
              <DatePicker
                label="От дата"
                name="startDate"
                onChange={handleInputChange}
                value={formState.startDate}
              />
            </div>
            <div>
              <DatePicker
                label="До дата"
                name="endDate"
                onChange={handleInputChange}
                value={formState.endDate}
              />
            </div>
            <div className="flex items-end pb-1">
              <label className="inline-flex cursor-pointer items-center gap-2">
                <input
                  type="checkbox"
                  name="extPol"
                  checked={formState.extPol}
                  onChange={handleInputChange}
                  className="form-checkbox text-primary h-3 w-3"
                />
                <span className="text-xs text-black dark:text-white">
                  Без чужди полици
                </span>
              </label>
            </div>
            <div className="flex items-end">
              <button
                type="submit"
                disabled={isLoading}
                className="bg-primary w-full justify-center rounded px-3 py-1.5 text-xs font-medium text-white hover:bg-opacity-90 disabled:opacity-50"
              >
                {isLoading ? "Зареждане..." : "Генерирай справка"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default FinancialAuditReport;
